module.exports = __webpack_public_path__ + "static/scroll_heatmap_login-fcb5be5856cd78e67f11ccca637ac85d.jpg";